const Footer = () => {
    return(
        <footer className="text-center py-2">
            <h6>&copy; Archana {new Date().getFullYear()}</h6>
        </footer>
    )
}


export default Footer;
